import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import {UtilsService} from "../../../shared/utils.service";
@Component({
    selector: 'app-certificate-details',
    templateUrl: './certificate-details.component.html',
    styleUrls: ['./certificate-details.component.scss'],
    standalone: false
})
export class CertificateDetailsComponent implements OnInit {
  certificate: any;

  constructor(public dialogRef: MatDialogRef<CertificateDetailsComponent>,
              private dataService: DataService, public utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.utils.showProgressDialog();
    this.dataService.get('certificate/RetrieveCertificateById/' + this.data.id,true).then((data) => {
      if (data.statusCode === 200) {
        this.certificate = data.data;
      }
      else{
        this.closeDialog()
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'You don\'t have access to Certificate',
            type: 'Info',
            message: 'You don\'t have access to Certificate',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  closeDialog() {
  this.dialog.closeAll();
  }

  forceDownload(blob, filename) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = blob;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  downloadResource(url, filename) {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop();
    }
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/octet-stream'
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      this.forceDownload(blobUrl, filename);
    })
    .catch(err => {
      console.error(err);
      this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Error',
          type: 'Error',
          message: 'Something went wrong, Please try again!',
          buttonText: 'Ok'
        }
      });
    });
  }

  downloadMyFile(url: any) {
    if (url) {
      this.downloadResource(url , this.certificate.fileName);
    }
  }

  downloadMyFileAndLog(certificate: any) {
    if (!certificate) return;

    const isValidFile = this.isValidFileExtension(certificate.path);
    if (!isValidFile) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'This is a Link',
          type: 'Info',
          message: 'The selected resource is a link and cannot be downloaded directly.',
          buttonText: 'Ok'
        }
      });
      return;
    }

    this.logMaterial(certificate.id);

    this.downloadMyFile(certificate.path);
  }

  logMaterial(id: any) {
    let materialLookup
    let materialId!: number;
    this.dataService.getMaterialTypes().then((data: any) => {
      materialLookup = data;
      for (let index = 0; index < materialLookup.length; index++) {
        const element = materialLookup[index];
        if(element.name === "ProductCertificate") {
          materialId = element.id;
        }
      }
      this.dataService.post('DownloadMaterial/DownloadProductMaterial/' + +materialId + '/' + id, null).then((data) => {
      });

    });
  }

  isValidFileExtension(filePath: string): boolean {
    const allowedExtensions = ['png', 'jpg', 'jpeg', 'txt', 'html', 'pdf', 'rtf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];

    const fileExtension = filePath.split('.').pop()?.toLowerCase();

    return allowedExtensions.includes(fileExtension!);
  }
}
